module.exports = __webpack_public_path__ + "static/media/ami_Canada.60c83796.png";


//////////////////
// WEBPACK FOOTER
// ./src/mi-app/digitalAssistant/assets/ami_Canada.png
// module id = 1438
// module chunks = 1